<template>
    <div class="login">
      <div v-if="from !== 'store'" style="position: relative;">
        <p class='login_tips'>{{$t('inputPayPwd')}}</p>
        <van-cell-group class="code_input">
          <van-field type="digit" ref="codeInput0" maxlength="6" @input="inputHandle" cursor="{codeValue[0].length}" :disabled="codeValue.join('').length !== 0 && codeValue.join('').length !== 1" v-model="codeValue[0]"/>
          <van-field type="digit" ref="codeInput1" maxlength="6" @input="inputHandle" cursor="{codeValue[1].length}" :disabled="codeValue.join('').length !== 1 && codeValue.join('').length !== 2" v-model="codeValue[1]"/>
          <van-field type="digit" ref="codeInput2" maxlength="6" @input="inputHandle" cursor="{codeValue[2].length}" :disabled="codeValue.join('').length !== 2 && codeValue.join('').length !== 3" v-model="codeValue[2]"/>
          <van-field type="digit" ref="codeInput3" maxlength="6" @input="inputHandle" cursor="{codeValue[3].length}" :disabled="codeValue.join('').length !== 3 && codeValue.join('').length !== 4" v-model="codeValue[3]"/>
          <van-field type="digit" ref="codeInput4" maxlength="6" @input="inputHandle" cursor="{codeValue[4].length}" :disabled="codeValue.join('').length !== 4 && codeValue.join('').length !== 5" v-model="codeValue[4]"/>
          <van-field type="digit" ref="codeInput5" maxlength="6" @input="inputHandle" cursor="{codeValue[5].length}" :disabled="codeValue.join('').length !== 5 && codeValue.join('').length !== 6" v-model="codeValue[5]"/>
        </van-cell-group>
        <!-- <van-password-input
            :value="codeValue"
            :mask="false"
            :focused="showKeyboard"
            @focus="kbShow"
            :gutter="4"
        /> 
        <van-number-keyboard
        v-model="codeValue"
        :show="showKeyboard"
        /> -->
        <div style="text-align: center; margin-top: 10px">
          <!-- <span class="p_link" is-link @click="copyHandle">{{$t('clickToCopy')}}</span> -->
          <span class="p_link" is-link @click="toFogetPage">{{$t('forgetPwd')}}</span>
        </div>
        <van-button type="danger" size="large" style="margin: 20px 10px 0;" @click="loginHandle">{{$t('login')}}</van-button>
        <!--国内展示 -->
        <div v-if="env == 'cn' && showIll" style="font-size: 12px;padding: 20px 10px;">充值说明：<br />1、充值仅限于<span style="color:red;">【官方大区】</span>用户使用；<br />2、需要将游戏版本更新到<span style="color:red;">1.12.000</span>以上。</div>
        <van-overlay :show="show">
          <div class="wrapper" @click.stop>
            <van-loading type="spinner" color="#e60012" style=""/>
          </div>
        </van-overlay>
      </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref } from 'vue';
import {mapGetters, mapActions} from 'vuex';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import qs from 'qs';

export default {
  name: 'Store',
  data(){
    return{
        showIll: window.location.host.split('.')[0] === 'jws2mall',
        codeValue: [],
        showKeyboard: true,
        show: false,
        roleShow: false,
        role: '',
        roleColumns: [],
        storage: localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : [],
        from: '',
        popShow: false,
        role: '',
        lang: '',
        selectData: {},
        env: "",
        diffLength: 0, //记录纯数组长度 与 删除后有空值的数组的差
        cnImg: require('@/assets/cn-img.jpg'),
        imgBox: {
          'zh-CN': {
            img1: require('@/assets/zh-img1.png'),
            img2: require('@/assets/zh-img2.png'),
          },
          'en-US': {
            img1: require('@/assets/en-img1.jpg'),
            img2: require('@/assets/en-img2.jpg'),
          },
          'th-TH': {
            img1: require('@/assets/en-img1.jpg'),
            img2: require('@/assets/en-img2.jpg'),
          },
          'id-ID': {
            img1: require('@/assets/id-img1.jpg'),
            img2: require('@/assets/id-img2.jpg'),
          },
          'zh-TW': {
            img1: require('@/assets/hk-img1.jpg'),
            img2: require('@/assets/hk-img2.jpg'),
          },
          'zh-HK': {
            img1: require('@/assets/hk-img1.jpg'),
            img2: require('@/assets/hk-img2.jpg'),
          },
          'ko-KR': {
            img1: require('@/assets/ko-img1.jpg'),
            img2: require('@/assets/ko-img2.jpg'),
          }
        }
    }
  },
  methods: {
    ...mapActions(['thirdPayLogin', 'getAllPayMode', 'checkRolesToken', 'checkUPay', 'getEmailFlag']),
    inputHandle(data){
    },
    toFogetPage(){
      this.getEmailFlag({
        appId: window.localStorage.getItem('appId'),
        uid: window.localStorage.getItem('uid')
      })
    },
    kbShow(){
      this.showKeyboard = true
    },
    inputHandle(){
      this.diffFlag = false
    },
    loginHandle(){
      this.checkUPay({
        payPassword: this.$md5(this.codeValue.join('')),
        uid: window.localStorage.getItem('uid'),
        appId: window.localStorage.getItem('appId')
      })
      this.show = true
    },
    onRoleConfirm(data){
      this.role = data.text
      this.selectData = this.cRoleList.validGameRole.filter(v => v.accessToken == data.value)[0]
      window.localStorage.setItem('accessToken', this.selectData.accessToken)
      window.localStorage.setItem('appId', this.selectData.appId)
      window.localStorage.setItem('roleName', this.selectData.roleName)
      if(this.selectData.serverName && this.selectData.serverName !== '0'){
        window.localStorage.setItem('serverName', this.selectData.serverName)
      }
      window.localStorage.setItem('tabActive', '')
      this.roleShow = false
    },
    roleHandle(){
      this.getAllPayMode({
        appId: this.selectData.appId,
        language: this.selectData.language,
        accessToken: this.selectData.accessToken
      })
    },
    toLogin(){
      this.from = ''
      this.$router.push({
        path: '/login'
      })
    },
  },
  computed:{
    ...mapGetters(['status', 'loading', 'userInfo', 'payModeInfo', 'pmLoading', 'cRoleList', 'crLoading', 'checkUPData', 'checkUPStatus', 'emailFlag', 'efLoading'])
  },
  mounted(){
    this.env = CONFIG.env
    this.from = this.$route.query.from
    this.lang = window.localStorage.getItem('language') || 'en-US'
    this.accessToken = window.localStorage.getItem('accessToken')
    this.appId = window.localStorage.getItem('appId')
    this.$nextTick(val => {
      this.$refs['codeInput0'].focus()
    })
    this.$watch(() => window.i18n.locale, val => {
      this.lang = val
    })
    this.$watch('efLoading', val => {
      if(val == 'loaded'){
        if(!this.emailFlag.isEmailSet){
          Dialog.confirm({
            title: this.$t('payTits'),
            message: this.$t('toSetEmailTits'),
            cancelButtonText: this.$t('backToLogin'),
            confirmButtonText: this.$t('toSetEmail')
          })
          .then(() => {
            this.$router.push({
              path: '/bindemail',
              query: {
                from: 'paylogin'
              }
            })
          })
          .catch(() => {
          });
        } else {
          this.$router.push({
            path: '/forgetPwd',
            query: {
              from: 'paylogin'
            }
          })
        }
      }
    })
    this.$watch('checkUPStatus', val => {
      if(val == 'stated'){
        if(this.checkUPData.loginResp){
          this.storage.push({
            accessToken: this.checkUPData.loginResp.accessToken,
            language: this.checkUPData.loginResp.language,
            appId: this.checkUPData.loginResp.appId,
            roleName: this.checkUPData.loginResp.roleName,
            serverName: this.checkUPData.loginResp.serverName
          })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('accessToken', this.checkUPData.loginResp.accessToken)
          window.localStorage.setItem('uid', '')
          setTimeout(() => {
            this.$router.push({
              path: '/store'
            })
          }, 500)
        } else {
          if(this.status !== -4){
            if(this.checkUPData < 5){
              Dialog.alert({
                message: this.$t('pwdErrorTimes', {msg: 5-this.checkUPData}),
                confirmButtonText: this.$t('sure'),
                type: "fail"
              })
            } else {
              Dialog.alert({
                message: this.$t('pwdErrorMax'),
                confirmButtonText: this.$t('sure'),
                type: "fail"
              })
            }
          }
          this.show = false
        }
      }
    })
    this.$watch('crLoading', val => {
      if(val === 'loaded'){
        window.localStorage.setItem('storage', JSON.stringify(this.cRoleList.validGameRole))
        this.roleColumns = this.cRoleList.validGameRole.map(v => {
          let returnData = {}
          returnData.text = v.roleName + ((v.serverName && (v.serverName !== '0')) ? ('(' + v.serverName + ')') : '')
          returnData.value = v.accessToken
          return returnData
        })
      }
    })
    this.$watch('pmLoading', val => {
      if(val === 'loaded'){
        if(this.payModeInfo.paymentInfo.length > 0){
          this.$router.push({
            path: '/store'
          })
          return false
        }
        Toast({
          message: this.$t('logError'),
          type: "fail"
        })
      }
    })
    this.$watch('loading', val => {
      if(val === 'loaded'){
        if(this.status == 0){
          this.show = false
          // this.storage.splice(this.storage.findIndex(v => v.accessToken == this.userInfo.loginResp.roleInfo.accessToken), 1)
          // this.storage.push({
          //   accessToken: this.userInfo.loginResp.accessToken,
          //   language: this.userInfo.loginResp.language,
          //   appId: this.userInfo.loginResp.appId,
          //   roleName: this.userInfo.loginResp.roleName,
          //   serverName: this.userInfo.loginResp.serverName,
          //   isUseLogin: this.userInfo.loginResp.isUseLogin
          // })
          window.localStorage.setItem('storage', JSON.stringify(this.storage))
          window.localStorage.setItem('accessToken', this.userInfo.loginResp.accessToken)
          window.localStorage.setItem('appId', this.userInfo.loginResp.appId)
          window.localStorage.setItem('roleName', this.userInfo.loginResp.roleName)
          if(this.userInfo.loginResp.serverName && this.userInfo.loginResp.serverName !== '0'){
            window.localStorage.setItem('serverName', this.userInfo.loginResp.serverName)
          }
          window.localStorage.setItem('isUseLogin', this.userInfo.loginResp.isUseLogin)
          if(this.userInfo.loginResp.isUseLogin){
            setTimeout(() => {
              this.$router.push({
                path: '/paylogin'
              })
            }, 500)
          } else {
            setTimeout(() => {
              this.$router.push({
                path: '/store'
              })
            }, 500)
          }
        } else {
          Toast({
            message: this.$t('checkLogCode'),
            type: "fail"
          })
          this.show = false
        }
      }
    })
    this.$watch('codeValue', (oldVal, val) => {
      let k = (val.filter(v => v !== '').length - 1)
      let v = val[k]
      if (v.length == 2){
        this.$nextTick(nVal => {
          this.$refs[`codeInput` + k].value = parseInt(v / 10) % 10
          this.$refs[`codeInput` + (k + 1)].focus()
        })
      } else if(v.length == 6){
        this.codeValue = v.split('')
        this.$nextTick(nVal => {
          this.$refs[`codeInput5`].focus()
        })
      } else  if(v.length == 1){
        if((this.diffLength < (val.length - 1) - k)){
          this.codeValue = []
          this.$nextTick(nVal => {
            this.$refs[`codeInput0`].focus()
          })
          // let changeVal = JSON.stringify(JSON.parse(v))
          // this.diffLength = (val.length - 1) - k
          // this.$nextTick(nVal => {
          //     this.$refs[`codeInput` + (val.join('').length - 1)].selectionStart = this.$refs[`codeInput` + (val.join('').length - 1)].selectionEnd = 1
          //   this.$refs[`codeInput` + (val.join('').length - 1)].focus()
          //   this.$refs[`codeInput` + (val.join('').length - 1)].value = ''
          //   this.$refs[`codeInput` + (val.join('').length - 1)].value = changeVal
          //   setTimeout(() => {
          //   }, 100)
          // })
        } else if((this.diffLength > (val.length - 1) - k)){
          this.diffLength = (val.length - 1) - k
          this.$nextTick(nVal => {
            this.$refs[`codeInput` + (k + 1)].focus()
          })
        } else {
          this.$nextTick(nVal => {
            this.$refs[`codeInput` + (k + 1)].focus()
          })
        }
      } else {
        this.codeValue = []
        this.$nextTick(nVal => {
          this.$refs[`codeInput` + k].value = ''
        })
      }
      // if(val.filter(v => v !== '').length=== 6){
      //   this.thirdPayLogin({
      //     loginCode: val.join('')
      //   })
      //   this.show = true
      // }
    })
  }
}
</script>

<style lang="scss">
.login{
  position: relative;
  margin: 10px;
  // .van-number-keyboard{
  //   position: relative;
  // }
  .code_input{
    display: flex;
    justify-content: space-around;
    margin: 0 16px;
    background-color: transparent;
    .van-cell{
      width: 14%;
      padding: 0;
      background-color: transparent;
    }
    input{
      height: 40px;
      text-align: center;
      background-color: #e9e9e9;
      border-radius: 6px;
      border: 0;
      &:disabled{
        color: #323233;
        -webkit-text-fill-color: #323233;
      }
      &:focus{
        background-color: #fff;
        border: 1px solid #e60012;
      }
    }
  }
  .van-field__control:read-only{
    text-overflow: ellipsis;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
  .p_link{
    text-align: center;
    margin-top: 20px;
    font-size: 10px;
    color: #e60012;
    text-decoration: underline;
    padding: 0 10px;
  }
  .van-dialog{
    max-height: 90vh;
    overflow-y: scroll;
    margin-top: 5vh;
  }
  .van-dialog__content{
    p{
      text-align: center;
    }
    img{
      width: 60%;
      position: relative;
      left: 20%;
    }
  }
}
</style>
